<!-- @veltra/icons generated sha256:6a5928b29fbf060c gen:8 source:src/svg/colorful/video.svg -->
<script setup lang="ts">
defineOptions({ name: 'UVideo' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#8b72f7"
        d="M10.29 1H4.207C2.987 1 2 1.987 2 3.206v9.578c0 1.22.989 2.208 2.208 2.208h7.586c1.22 0 2.208-.989 2.208-2.208V4.71c0-.497-.197-.974-.549-1.326l-1.836-1.836A1.88 1.88 0 0 0 10.29 1"
      />
      <path
        fill="#6e52ea"
        d="m13.452 3.384-1.836-1.836a1.9 1.9 0 0 0-.965-.514v2.06c0 .655.53 1.185 1.185 1.185h2.115a1.87 1.87 0 0 0-.5-.895"
      />
      <path
        fill="#7463ea"
        d="M8.52 6.62H4.625A.625.625 0 0 0 4 7.245V9.68c0 .345.28.625.625.625H8.52c.346 0 .625-.28.625-.625V7.245a.626.626 0 0 0-.625-.625m2.836.095-1.31 1.224a.717.717 0 0 0 0 1.05l1.31 1.223c.222.208.586.05.586-.253v-2.99a.348.348 0 0 0-.586-.254"
      />
      <path
        fill="#fff"
        d="M8.52 6.432H4.625A.625.625 0 0 0 4 7.057v2.436c0 .346.28.625.625.625H8.52c.346 0 .625-.28.625-.625V7.057a.626.626 0 0 0-.625-.625m2.836.096-1.31 1.223a.717.717 0 0 0 0 1.05l1.31 1.224c.222.207.586.05.586-.254v-2.99a.348.348 0 0 0-.586-.253"
      />
    </g>
  </svg>
</template>
